// Utility for navigating to the procedure screen
export function navigateToProcedureScreenUtil({
    dispatch,
    setProgressBarStatus,
    currentActivity,
    setCurrentActivity,
    REPORTPROGRESSTEPS,
    getModifiedButtonVisibilities,
    myCaseResourceType,
    footerButtonStatuses,
    procedure,
    usageDetails,
    t,
    review,
    setFooterButtonStatuses
}) {
    dispatch(setProgressBarStatus(currentActivity));
    setCurrentActivity(
        REPORTPROGRESSTEPS[
            REPORTPROGRESSTEPS.findIndex(
                (activity) => activity === currentActivity
            ) + 1
        ]
    );
    const modifiedButtonStatuses = getModifiedButtonVisibilities(
        myCaseResourceType,
        footerButtonStatuses,
        procedure,
        usageDetails &&
            usageDetails.unidId &&
            usageDetails?.unidSurgeryInfoPage?.deliveredRodItems?.length > 0
            ? t('reportUsage.progressBar.UNiDInfo')
            : review,
        true
    );
    setFooterButtonStatuses(modifiedButtonStatuses);
}
